import { WebStorageStateStore } from 'oidc-client-ts';

export const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY,
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: `${window.location.origin}${process.env.REACT_APP_BASE_PATH}/callback`,
  post_logout_redirect_uri: `${window.location.origin}${process.env.REACT_APP_BASE_PATH}/`,
  response_type: 'code',
  scope: 'openid email',
  automaticSilentRenew: false, // disabled — custom scheduleRenewal in AuthContext handles token renewal via Gateway
  useRefreshTokens: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};
